import React, { createContext, useReducer, ReactNode, Dispatch } from 'react';
import Reducer, { Action, State } from '../../reducers/regform-fields/password-field-reducer';

type NewPasswordFieldContextType = [State, Dispatch<Action>];

const initialState: State = {
	value: '',
	error: {
		message: '',
		show: false,
	},
	valid: null,
};

export const NewPasswordFieldContext = createContext<NewPasswordFieldContextType>([initialState, () => null]);
interface PasswordFieldStoreProps {
	children: ReactNode;
}

const PasswordFieldStore: React.FC<PasswordFieldStoreProps> = ({ children }) => {
	const [state, dispatch] = useReducer(Reducer, initialState);
	return (
		<NewPasswordFieldContext.Provider value={[state, dispatch]}>
			{children}
		</NewPasswordFieldContext.Provider>
	);
};

export default PasswordFieldStore;
